var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-promo',{attrs:{"size":"dropdown","data-qa":"applicant-limit-promo"},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('apply-button',{attrs:{"reason":"promo.tariff_upgrade.reason.limit-candidates"}})]},proxy:true}])},[_c('tariff-badge',{attrs:{"tariff-group":_vm.unlimitedTariffGroup}}),_vm._v(" "),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$trlMessage('applicants-limit.promo.title'))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$trlMessage('applicants-limit.promo.descr', {
        tariffName: _vm.unlimitedTariffGroup.name
      })
    )}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }